// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1vWAQ","content":"Consent_content__1ts7b","footer":"Consent_footer__ikhfl"};